import * as React from 'react';

function SvgMastercardColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 39 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="MastercardColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={11}
        y={15}
        width={17}
        height={3}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15.905h15.248v1.994H12v-1.995z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#MastercardColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.09 17.723v.033h.031a.03.03 0 00.017-.004c.004-.003.006-.007.006-.013a.014.014 0 00-.006-.012.03.03 0 00-.017-.004h-.03zm.031-.024c.016 0 .028.003.037.01a.038.038 0 01.013.03c0 .01-.004.02-.01.026a.05.05 0 01-.03.013l.04.047h-.03l-.038-.047h-.012v.047h-.027V17.7h.057zm-.008.17a.1.1 0 00.072-.031.107.107 0 00-.032-.173.105.105 0 00-.08 0 .102.102 0 00-.055.056.11.11 0 00.022.117c.01.01.02.017.033.022a.098.098 0 00.04.009zm0-.242a.133.133 0 01.124.083.14.14 0 01-.028.149.14.14 0 01-.043.029.129.129 0 01-.052.01.13.13 0 01-.097-.04.137.137 0 01.097-.232zM14.67 17.14c0-.24.153-.439.405-.439.24 0 .401.19.401.439 0 .25-.161.438-.401.438-.252 0-.405-.197-.405-.438zm1.08 0v-.685h-.29v.166a.501.501 0 00-.422-.2c-.374 0-.667.3-.667.719 0 .418.293.72.667.72.19 0 .33-.078.422-.201v.166h.29v-.685zm9.8 0c0-.24.153-.439.404-.439.24 0 .402.19.402.439 0 .25-.162.438-.402.438-.25 0-.404-.197-.404-.438zm1.08 0v-1.236h-.29v.717a.5.5 0 00-.422-.2c-.374 0-.666.3-.666.719 0 .418.292.72.666.72.19 0 .33-.078.422-.201v.166h.29v-.685zm-7.28-.453c.187 0 .306.12.337.332h-.692c.03-.197.148-.332.355-.332zm.005-.267c-.39 0-.664.293-.664.72 0 .436.285.72.684.72.2 0 .385-.052.547-.193l-.143-.22a.625.625 0 01-.387.143c-.188 0-.358-.089-.4-.335h.991c.003-.038.006-.075.006-.115-.003-.427-.26-.72-.634-.72zm3.502.72c0-.24.153-.439.405-.439.24 0 .401.19.401.439 0 .25-.161.438-.401.438-.252 0-.405-.197-.405-.438zm1.08 0v-.685h-.29v.166a.5.5 0 00-.421-.2c-.374 0-.667.3-.667.719 0 .418.293.72.667.72a.5.5 0 00.42-.201v.166h.291v-.685zm-2.718 0c0 .415.282.72.712.72a.686.686 0 00.48-.164l-.14-.24a.576.576 0 01-.349.122c-.231-.002-.402-.174-.402-.438s.17-.436.402-.439c.126 0 .24.043.35.124l.139-.241a.687.687 0 00-.48-.163c-.43 0-.712.303-.712.719zm3.74-.72a.391.391 0 00-.352.201v-.166h-.287v1.37h.29v-.768c0-.227.095-.353.284-.353.059 0 .12.009.182.035l.089-.281a.606.606 0 00-.207-.037zm-7.775.144a.975.975 0 00-.544-.143c-.338 0-.555.166-.555.438 0 .224.162.361.46.404l.137.02c.159.023.234.066.234.143 0 .107-.106.167-.304.167a.7.7 0 01-.444-.143l-.136.232c.159.12.36.177.577.177.385 0 .609-.186.609-.447 0-.24-.176-.366-.466-.41l-.137-.02c-.126-.017-.226-.043-.226-.134 0-.1.095-.161.254-.161.17 0 .334.066.416.118l.125-.241zm3.742-.143a.392.392 0 00-.352.2v-.166h-.287v1.37h.29v-.768c0-.227.095-.353.285-.353.058 0 .12.009.181.035l.09-.281a.61.61 0 00-.207-.037zm-2.475.034h-.474v-.416h-.293v.416h-.27v.272h.27v.625c0 .318.12.507.463.507.126 0 .27-.04.363-.106l-.084-.255a.526.526 0 01-.257.078c-.145 0-.192-.092-.192-.23v-.619h.474v-.272zm-4.336 1.37v-.86c0-.324-.201-.541-.525-.544a.513.513 0 00-.469.243.486.486 0 00-.44-.244.437.437 0 00-.391.204v-.17H12v1.371h.293v-.76c0-.238.128-.364.326-.364.193 0 .29.13.29.362v.762h.293v-.76c0-.238.134-.364.327-.364.198 0 .293.13.293.362v.762h.293z"
          fill="#020303"
        />
      </g>
      <mask
        id="MastercardColour_svg__b"
        maskUnits="userSpaceOnUse"
        x={11}
        y={4}
        width={17}
        height={14}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.158 17.899h16.255V4.91H11.158v12.988z"
          fill="#fff"
        />
      </mask>
      <g
        mask="url(#MastercardColour_svg__b)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path d="M17.088 14.127h4.395V6.014h-4.395v8.113z" fill="#F16522" />
        <path
          d="M17.367 10.07c0-1.645.75-3.111 1.918-4.056a4.919 4.919 0 00-3.104-1.103c-2.774 0-5.023 2.31-5.023 5.16s2.249 5.16 5.023 5.16c1.172 0 2.25-.413 3.104-1.104a5.203 5.203 0 01-1.918-4.056z"
          fill="#E41B24"
        />
        <path
          d="M27.256 13.268v-.2h-.051l-.058.137-.059-.137h-.05v.2h.035v-.151l.055.13h.037l.055-.13v.15h.036zm-.322 0v-.166h.065v-.034h-.166v.034h.065v.166h.036zm.479-3.198c0 2.85-2.249 5.16-5.023 5.16a4.917 4.917 0 01-3.104-1.103 5.202 5.202 0 001.918-4.057c0-1.646-.75-3.112-1.918-4.056A4.919 4.919 0 0122.39 4.91c2.774 0 5.023 2.31 5.023 5.16z"
          fill="#F89E1B"
        />
      </g>
    </svg>
  );
}

export default SvgMastercardColour;
